// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mI7q","fullView":"styles_fullView__32rF9"};